// @ts-ignore
import useApi from "./ServiceClient.tsx";
import { config } from "./config";

export const useBlockchainRequest = () => {
  const { GET, POST, publicRequest } = useApi(); // Use API methods inside a React hook

  const getRequests = () => {
    const response = GET(
      `${config?.blockchain_management?.END_POINTS?.REQUEST_GET_ALL}`
    );
    return response;
  };

  const getRequestById = (id) => {
    const response = GET(
      `${config?.blockchain_management?.END_POINTS?.REQUEST_GET}/${id}`
    );
    return response;
  };

  const createRequest = (data) => {
    const response = POST(
      config?.blockchain_management?.END_POINTS?.REQUEST_CREATE,
      data
    );
    return response;
  };

  const updateRequest = (data) => {
    const response = POST(
      config?.blockchain_management?.END_POINTS?.REQUEST_UPDATE,
      data
    );
    return response;
  };

  const requestApprove = (requestId) => {
    const response = POST(
      `${config?.blockchain_management?.END_POINTS?.REQUEST_APPROVAL}/${requestId}`,
      null
    );
    return response;
  };

  const requestReject = (requestId) => {
    const response = POST(
      `${config?.blockchain_management?.END_POINTS?.REQUEST_REJECT}/${requestId}`,
      null
    );
    return response;
  };

  const requestCancel = (requestId) => {
    const response = POST(
      `${config?.blockchain_management?.END_POINTS?.REQUEST_CANCEL}/${requestId}`,
      null
    );
    return response;
  };

  const getRequestByHash = (hash) => {
    const response = GET(
      `${config?.blockchain_management?.END_POINTS?.REQUEST_BY_HASH}/${hash}`
    );
    return response;
  };

  const getPublicRequestByHash = (hash, tenant) => {
    const response = publicRequest(
      `${config?.blockchain_management?.END_POINTS?.REQUEST_BY_HASH_PUBLIC}/${tenant}/${hash}`
    );
    return response;
  };

  return {
    getRequests,
    getRequestById,
    createRequest,
    updateRequest,
    requestApprove,
    requestReject,
    requestCancel,
    getRequestByHash,
    getPublicRequestByHash
  };
};
